import { parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

const TZ = 'America/Sao_Paulo';

export function formatBRL(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatPercent(value: number, decimals = 2): string {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value) + '%';
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('pt-BR').format(Math.round(value));
}

export function formatDecimal(value: number, decimals = 2): string {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

export function formatDate(dateStr: string): string {
  try {
    return formatInTimeZone(parseISO(dateStr), TZ, 'dd/MM/yyyy');
  } catch {
    return dateStr;
  }
}

export function formatDatetime(dateStr: string): string {
  try {
    return formatInTimeZone(new Date(dateStr), TZ, 'dd/MM/yyyy HH:mm');
  } catch {
    return dateStr;
  }
}

export function formatMonth(monthStart: string): string {
  try {
    return formatInTimeZone(parseISO(monthStart), TZ, 'MMM yyyy');
  } catch {
    return monthStart;
  }
}
